import styled from 'styled-components';
import { NavLink } from "react-router-dom";
import { ReactComponent as BarsSvg } from '../../assets/icons/fa-bars.svg';
import { ReactComponent as XMarkSvg } from '../../assets/icons/fa-xmark.svg';
import { HOME, UPLOADING, HELP, DRONE_MAP } from "../../Routes";

export const MenuWrapper = styled.div`
  display: none;

  & > ul {
    margin-top: 3px;
    align-items: center;
    padding: 0;
    user-select: none;
    display: inline-flex;

    li {
      font-weight: 700;
      list-style: none;
      padding: 0 20px;
      cursor: pointer;

      a {
        border-bottom: 3px solid ${({theme}) => theme.colors.brand_tint_yellow};
        padding-bottom: 3px;
        text-decoration: none;
        color: ${({theme}) => theme.colors.heading_dark};
        opacity: .75;
      }

      a:hover {
        color: ${({theme}) => theme.colors.heading_dark};
        opacity: .6;
      }

      a.active {
        color: ${({theme}) => theme.colors.heading_dark};
        border-bottom: 3px solid ${({theme}) => theme.colors.brand_yellow};
        padding-bottom: 3px;
        text-decoration: none;
        opacity: 1;
      }

      a.active:hover {
        color: ${({theme}) => theme.colors.heading_dark};
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: 768px) {
    display: block;
  }
`;

export const MobileMenuWrapper = styled.div`
  position: fixed;
  display: flex;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  background-color: ${({theme}) => theme.colors.brand_yellow};

  div {
    display: flex;
    width: 100%;
    background-color: ${({theme}) => theme.colors.white};
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
  }

  ul {
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: ${({theme}) => theme.colors.brand_yellow};
    flex: 0 0 100%;
    height: 100%;
    align-items: flex-start;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;

    li {
      margin: 3px 0;
    }

    li a {
      font-size: 20px;
      font-weight: 700;
      color: ${({theme}) => theme.colors.heading_dark};
      text-decoration: none;
      text-align: left;
      padding: 2px 40px 7px 2px;
      cursor: pointer;

      &.active {
        color: ${({theme}) => theme.colors.white};
      }

      &:hover {
        color: ${({theme}) => theme.colors.white};
      }
    }
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const MenuToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const MenuIcon = styled(BarsSvg)`
  width: 20px;
  height: auto;
  fill: ${({theme}) => theme.colors.text_dark};
  cursor: pointer;

  &:hover {
    fill: ${({theme}) => theme.colors.link_hover};
  }
`;

export const CloseIcon = styled(XMarkSvg)`
  width: 18px;
  height: auto;
  fill: ${({theme}) => theme.colors.text_dark};
  cursor: pointer;

  &:hover {
    fill: ${({theme}) => theme.colors.link_hover};
  }
`;

export function MenuItems ({onLinkClick}) {
  return (
    <ul>
      <li>
        <NavLink to={HOME} onClick={onLinkClick}>Home</NavLink>
      </li>
      <li id="droneMap">
        <NavLink to={DRONE_MAP} onClick={onLinkClick}>Map</NavLink>
      </li>
      <li>
        <NavLink to={UPLOADING} onClick={onLinkClick}>Uploading</NavLink>
      </li>
      <li>
        <NavLink to={HELP} onClick={onLinkClick}>Help</NavLink>
      </li>
    </ul>
  );
}